import {
  Box,
  Button,
  Divider,
  GridItem,
  Input,
  SimpleGrid,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../LoadingSpinner";
import SectionDivider from "../../Components/Common/SectionDivider";
import CaseNote from "../../Components/SharedComponent/CaseNote";
import ScrollCircle from "../../Components/Common/ScrollCircle";
import SearchCaseModal from "../../Components/Common/SearchCaseModal";

const CaseDetailsPage = () => {
  const [data, setData] = useState({});
  const [clickedCaseId, setClickCaseId] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { id, source } = useParams();

  // =====================search box
  const {
    isOpen: isSearchBoxOpen,
    onOpen: onSearchBoxOpen,
    onClose: onSearchBoxClose,
  } = useDisclosure();

  useEffect(() => {
    if (clickedCaseId.id) {
      setIsLoading(true);
      fetch(
        `/api/getcase?id=${clickedCaseId.id}&source=${clickedCaseId.source}`
      )
        .then((response) => response.json())
        .then((json) => {
          setData(json);
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  }, [clickedCaseId.id, clickedCaseId.source]);

  const handleSearchBoxClick = () => {
    onSearchBoxOpen();
  };

  // =============================only for params
  useEffect(() => {
    setIsLoading(true);
    fetch(`/api/getcase?id=${id}&source=${source}`)
      .then((response) => response.json())
      .then((json) => {
        setData(json);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [id, source]);

  // field render
  const renderFields = (fields) => {
    return Object.keys(fields).map((fieldKey) => {
      const field = fields[fieldKey];

      if (Array.isArray(field)) {
        if (
          field &&
          field != null &&
          field.length > 0 &&
          Object?.keys(field?.[0])?.length === 1
        ) {
          return field.map((item, idx) => {
            return Object?.keys(item).map((innerKey) => (
              <>
                {idx === 0 && (
                  <GridItem colSpan={{ base: 1, md: 3 }}>
                    <Text fontWeight={500} fontSize="lg">
                      {fieldKey}
                    </Text>
                  </GridItem>
                )}
                <Box key={innerKey}>
                  <Text fontWeight={500}>{item[innerKey]?.MESSAGE}</Text>
                  <Input
                    value={item[innerKey]?.VALUE || ""}
                    isReadOnly={!item[innerKey]?.EDITABLE}
                  />
                </Box>
              </>
            ));
          });
        }
        return field.map((item, idx) => {
          return (
            <GridItem colSpan={{ base: 1, md: 3 }}>
              <SimpleGrid columns={[1, 2, 3]} spacing={4}>
                {Object.keys(item).map((innerKey) => (
                  <Box key={innerKey} mb={4}>
                    <Text fontWeight={500}>{item[innerKey]?.MESSAGE}</Text>
                    <Input
                      value={item[innerKey]?.VALUE || ""}
                      isReadOnly={!item[innerKey]?.EDITABLE}
                    />
                  </Box>
                ))}

                {/* Add a Divider except after the last group */}
                {idx !== field.length - 1 && (
                  <GridItem colSpan={{ base: 1, md: 3 }}>
                    <Divider my={2} h="2px" bg="gray.100" />{" "}
                  </GridItem>
                )}
              </SimpleGrid>
            </GridItem>
          );
        });
      } else if (typeof field === "object") {
        return (
          <Box key={fieldKey} mb={4}>
            <Text fontWeight={500}>{field.MESSAGE}</Text>
            <Input value={field.VALUE || ""} isReadOnly={!field.EDITABLE} />
          </Box>
        );
      }
      return null;
    });
  };

  const renderSections = () => {
    return Object.keys(data).map((sectionKey) => {
      const section = data[sectionKey];
      return (
        <Box key={sectionKey} mb={8} px={5}>
          <Box my={5}>
            <SectionDivider message={section.MESSAGE} />
          </Box>
          <SimpleGrid columns={[1, 2, 3]} spacing={4}>
            {section?.MESSAGE !== "Case Notes" ? (
              renderFields(section.FIELDS)
            ) : (
              <CaseNote caseData={section?.FIELDS?.CASE_NOTES} />
            )}
          </SimpleGrid>
        </Box>
      );
    });
  };

  return (
    <Box mt={2}>
      {isLoading && <LoadingSpinner />}
      {!isLoading && Object.values(data).length > 0 && (
        <Box m={8}>
          <Box w={{ base: "100%", md: "100px" }}>
            <Button
              variant="primaryButton"
              onClick={handleSearchBoxClick}
              w={{ base: "100%" }}
            >
              Search Case
            </Button>
          </Box>
          <Box position="fixed" left={2} top="20%">
            <ScrollCircle data={data} />
          </Box>
          {renderSections()}
        </Box>
      )}

      {!isLoading && Object.values(data).length === 0 && (
        <Box
          h="50vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontSize="xl" fontWeight={500} color="red">
            No data found
          </Text>
        </Box>
      )}
      <Divider my={4} />
      <SearchCaseModal
        isOpen={isSearchBoxOpen}
        onClose={onSearchBoxClose}
        onOpen={onSearchBoxOpen}
        clickedCaseId={clickedCaseId}
        setClickCaseId={setClickCaseId}
      />
    </Box>
  );
};

export default CaseDetailsPage;
